import { render, staticRenderFns } from "./industryTes.vue?vue&type=template&id=cfc75a7a&scoped=true"
import script from "./industryTes.vue?vue&type=script&lang=js"
export * from "./industryTes.vue?vue&type=script&lang=js"
import style0 from "./industryTes.vue?vue&type=style&index=0&id=cfc75a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc75a7a",
  null
  
)

export default component.exports